const STATUS_VARIANTS = {
  active: "bg-green-100 text-green-800",
  inactive: "bg-red-100 text-red-800",
  pending: "bg-amber-100 text-amber-800",
  approved: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  blocked: "bg-red-100 text-red-800",
  read: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  unread: "bg-blue-50 text-blue-700 ring-blue-600/20",
};

const StatusBadge = ({
  variant = "active",
  children,
  className = "",
  withRing = false,
}) => {
  const variantClass = STATUS_VARIANTS[variant] ?? STATUS_VARIANTS.active;
  const ringClass = withRing ? "ring-1 ring-inset" : "";

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold leading-5 ${variantClass} ${ringClass} ${className}`}
    >
      {children}
    </span>
  );
};

export const getStatusVariant = (status) => {
  if (status === 1 || status === "1" || status === true) return "active";
  if (status === 0 || status === "0" || status === false) return "inactive";
  if (status === 2 || status === "2") return "rejected";
  return "pending";
};

export const getApprovalVariant = (status) => {
  if (status === 1 || status === "1") return "approved";
  if (status === 2 || status === "2") return "rejected";
  return "pending";
};

export default StatusBadge;
